// @ts-check
import {
  wrapFormComponentWithLabelAndError,
  wrapFormComponentWithError,
} from './StyledFormComponentWrappers';
import CountySelection from 'shared/components/CountySelection';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';

const RawCountySelectionField = wrapFormComponentWithLabelAndError(CountySelection);
RawCountySelectionField.displayName = 'RawCountySelectionField';

const CountySelectionField = connectFormComponentToReduxForm(RawCountySelectionField);
CountySelectionField.displayName = 'CountySelectionField';

export default CountySelectionField;

const CountySelectionInput = connectFormComponentToReduxForm(
  wrapFormComponentWithError(CountySelection)
);

export { CountySelectionInput };
